import { fetchFdpqMakeList } from '../fetchers';

export default function checkIsShowDdpFdpq() {
    return async (ctx) => {
        if (ctx.data.owner?.id) {
            const makeList = await fetchFdpqMakeList(ctx.data.owner.id);
            ctx.data.showDdpFdpq = makeList && makeList.length > 0;
        }
    };
}
